import type { Permission } from '@ztechapps/common.contract'

export const blogPermissions = {
  canView: {
    value: 'blog.canView',
    label: 'Can View',
    description: 'No modification can be done to the blog, only viewing of details.',
  } satisfies Permission,
  canEdit: {
    value: 'blog.canEdit',
    label: 'Can Edit',
    description: 'Can modify the records for all fields of blog',
  } satisfies Permission,
  canDelete: {
    value: 'blog.canDelete',
    label: 'Can Delete',
    description:
      'Can delete the records for all fields of blog. This will delete entire record and cannot be recovered.',
  } satisfies Permission,
}
